import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reducer } from './store/assign-to-me.reducers';
import { AssignToMeEffects } from './store/assign-to-me.effects';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ AssignToMeEffects ]),
    StoreModule.forFeature('assignToMe', reducer),
  ],
})
export class AssignToMeModule {}
